import './styles.scss';

import { Card, Col, Row } from 'react-bootstrap';
import { ReactElement, useEffect } from 'react';

import AutomationTripsFilters from '@/features/Automation/pages/AutomationTrips/components/AutomationTripsFilters';
import AutomationTripsTable from '@/features/Automation/pages/AutomationTrips/components/AutomationTripsTable';
import { AutomationTripsTypes } from '@/features/Automation/pages/AutomationTrips/types';
import { Dayts } from '@/utils';
import Feature from '@/common/Feature';
import Lottie from '@/common/Lottie';
import { createPersistentComponentState } from '@/state';
import { customIndexedDBStorage } from '@/state/storage';
import useInterval from '@/hooks/useInterval';
import useSession from '@/state/session';

export const useAutomationTrips = createPersistentComponentState<AutomationTripsTypes.State>(
  'AutomationTripsState',
  AutomationTripsTypes.initState,
  {
    storage: customIndexedDBStorage,
  }
);

const AutomationTrips = (): ReactElement => {
  const [{ processing, from, to, market, total, pollAutomation, pollStatus }] = useAutomationTrips(({ state }) => [
    {
      processing: state.processing,
      from: state.filters?.from,
      to: state.filters?.to,
      market: state.filters?.market?.replace(/,/g, ', '),
      total: state.total,
      pollAutomation: state.pollAutomation,
      pollStatus: state.pollStatus,
    },
  ]);

  useEffect(() => {
    if (useSession.getState().state?.config?.auth?.allowRunScheduleAutomation) return;
    window.location.href = '/';
  }, []);

  useInterval(pollAutomation, processing ? AutomationTripsTypes.POLLING_TIMES[pollStatus] || 1000 : null, true);

  return (
    <Feature name="Automation-Trips">
      {processing && (
        <Lottie name="Loading">
          <h4>We&apos;re processing these updates in the background. You can keep working in Skyplan while automation completes.</h4>
        </Lottie>
      )}
      <Card>
        <Card.Header>
          <Card.Title>Create Automated Schedule</Card.Title>
          {market && (
            <span className="text-muted">
              {new Dayts(from).format('MM/DD/YY')} to {new Dayts(to).format('MM/DD/YY')} - {market} &bull; {total} Trips
            </span>
          )}
        </Card.Header>
        <Card.Body>
          <AutomationTripsFilters />
        </Card.Body>
        <Card.Body>
          <Row>
            <Col>
              <AutomationTripsTable />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Feature>
  );
};

export default AutomationTrips;
